
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SideMenu from './SideMenu.vue';
import BreadCrumb from '@/components/BreadCrumb.vue';
import { DashboardDTO } from '@/data/dto/dashboards.dto';

@Component({
  components: {
    SideMenu,
    BreadCrumb,
  },
})
export default class IFramePage extends Vue {
  @Prop(String) private src?: string;

  private isSidebarMenuEnabled = false;

  get contentWidthClass(): string[] {
    return this.isSidebarMenuEnabled ? ['w-75', 'with-sidebar'] : ['w-100', 'px-4'];
  }

  get headerOffsetClass(): string {
    return this.isSidebarMenuEnabled ? 'header-offset' : '';
  }

  get currentRouteIFrameLink(): string {
    return this.$route.meta && this.$route.meta.iFrameSrc
      ? this.$route.meta.iFrameSrc
      : '';
  }

  get iFrameSrc(): string {
    return this.src || this.currentRouteIFrameLink;
  }

  get currentTitleIFramePage(): string {
    return this.$route.meta && this.$route.meta.title
      ? this.$route.meta.title
      : '';
  }

  get currentSubTitleIFramePage(): string {
    return this.$route.meta && this.$route.meta.subtitle
      ? this.$route.meta.subtitle
      : '';
  }

  // O meta da rota é montado uma vez só, então busca o valor atual do dashboard.
  @Watch('$route.meta.id', { immediate: true })
  async loadSidebarMenuSetting() {
    const meta = this.$route.meta;

    this.isSidebarMenuEnabled = !!meta?.isSidebarMenuEnabled;
    if (!meta?.id) {
      return;
    }
    const dashboards: DashboardDTO[] =
      (await this.$store.dispatch('getAllDashboards')) || [];

    const currentDashboard = dashboards.find((dashboard) => dashboard.id === meta.id);

    if (currentDashboard && this.$route.meta?.id === meta.id) {
      this.isSidebarMenuEnabled = !!currentDashboard.isSidebarMenuEnabled;
    }
  }
}
